"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HousesStatistic = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./HousesStatistic.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HousesStatistic = props => {
  const {
    deadlineViolationsPercent
  } = props;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles['data']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['text']
  }, props.housesDeadlineText), /*#__PURE__*/React.createElement("div", null, props.completedHouses)), /*#__PURE__*/React.createElement("i", {
    className: styles['percent-bar'],
    style: {
      background: `linear-gradient(to right, #34ac0a ${100 - deadlineViolationsPercent}%, #db6f0a ${100 - deadlineViolationsPercent}%  ${deadlineViolationsPercent}%`
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['percent']
  }, deadlineViolationsPercent, "% \u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u043E\u0432"));
};
exports.HousesStatistic = HousesStatistic;